<template>
	<div class="order-status-page">
		<div class="order-success-banner">
			<img src="/images/success-bag.gif" alt="Boom Food Gif" />
		</div>
		<div class="order-success-content">
			<button class="button button-white reset-button">START OVER</button>
			<h4 class="order-success-subtitle">Boom!</h4>
			<h1 class="order-success-title">Order Placed</h1>
			<div class="order-success-id">#{{ orderId }}</div>
			<img
				class="order-delivery-hint-image"
				:src="deliveryHintImagePath"
				alt="Delivery Hint"
			/>
			<div class="order-delivery-hint-title">{{ deliveryHintTitle }}</div>
			<div class="order-delivery-hint-subtitle">
				{{ deliveryHintText }}
			</div>
		</div>
	</div>
</template>

<style scoped>
.order-status-page {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
}

.order-success-banner {
	background: var(--sk-green);
	width: 35%;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.order-success-banner img {
	width: 66%;
	max-width: 278px;
}

.order-success-content {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 65%;
}

.order-success-title {
	margin-bottom: 56px;
	font-size: 8.04vw;
}

.order-success-subtitle {
	font-size: 4.04vw;
}

.order-success-subtitle,
.order-success-title {
	color: var(--gR-base-90);
	font-weight: 700;
}

.order-success-id {
	color: var(--sk-grey3);
	margin-bottom: 98px;
	font-size: 2.02vw;
}

.order-delivery-hint-title {
	color: var(--gR-base-90);
	font-weight: 700;
	margin: 22px 0;
	font-size: 2.02vw;
}

.order-delivery-hint-subtitle {
	color: var(--sk-grey3);
	font-size: 1.33vw;
}

.order-delivery-hint-image {
	height: 9.5vw;
}

.reset-button {
	position: absolute;
	top: 20px;
	right: 20px;
	font-weight: normal;
	height: 40px;
	min-width: 116px;
	max-width: 100%;
	width: auto;
}
</style>

<script>
import orderSuccessMixin from "@/mixins/order-success-mixin"

export default {
	name: "OrderSuccess",
	mixins: [orderSuccessMixin],
	mounted: function () {
		this.$store.dispatch("getOrderStatus", {
			orderId: this.orderId,
			skipDeliveryStatus: true
		})

		setTimeout(() => {
			this.$router.push({ path: `/${this.$route.params.slug}/menu` })
		}, 60000)
	}
}
</script>